import {
    CLOSE_SLIDER,
    COURSES_IS_LOADING,
    COURSES_LOAD_ERROR,
    COURSES_LOAD_SUCCESS,
    IS_LOADING,
    IS_SUBMITTING,
    IS_SUBMITTING_QUESTIONS,
    LOAD_ERROR,
    LOAD_SUCCESS,
    OPEN_SLIDER,
    QUIZZES_IS_LOADING,
    QUIZZES_LOAD_ERROR,
    QUIZZES_LOAD_SUCCESS,
    RESET_EDIT,
    RESET_FORM_STATUS,
    RESET_QUESTIONS_FORM_STATUS,
    RESET_QUIZZES_DATA,
    SELECTED_MENU_ITEM,
    SET_EDIT,
    SET_HEADER_BUTTON_PARAMS,
    SET_HEADER_TEXT,
    SUBMIT_ERROR,
    SUBMIT_QUESTIONS_ERROR,
    SUBMIT_QUESTIONS_SUCCESS,
    SUBMIT_SUCCESS,
    SETTINGS_IS_LOADING,
    SETTINGS_LOAD_SUCCESS,
    SETTINGS_LOAD_ERROR,
    ANNOUNCEMENTS_IS_LOADING,
    ANNOUNCEMENTS_LOAD_SUCCESS,
    ANNOUNCEMENTS_LOAD_ERROR,
    IS_UPDATING,
    UPDATE_SUCCESS,
    UPDATE_ERROR,
    COURSES_INTEGRITY_ERROR,
    RESET_INTERGRITY_ERROR,
    STATISTICS_IS_LOADING,
    STATISTICS_LOAD_SUCCESS,
    STATISTICS_LOAD_ERROR,
    LEADERSHIP_BOARD_IS_LOADING,
    LEADERSHIP_BOARD_LOAD_SUCCESS,
    LEADERSHIP_BOARD_LOAD_ERROR,
    REPORTS_IS_LOADING,
    REPORTS_LOAD_SUCCESS,
    REPORTS_LOAD_ERROR,
    RESET_LOADED_QUESTIONS,
    SELECTED_COURSE_IS_LOADING,
    SELECTED_COURSE_LOAD_SUCCESS,
    SELECTED_COURSE_LOAD_ERROR,
    RESET_SELECTED_COURSE,
    SEARCH_AUTOCOMPLETE_LIST_LOADING,
    SEARCH_QUERY_LOADING,
    SEARCH_COMPONENT_RESET,
    SEARCH_FINAL_QUERY,
    SET_AUTOCOMPLETE_VISIBILITY,
    CURRENT_VIEW,
    RESET_VIEW,
    SET_HEADER_ADVANCED_SEARCH_PARAMS,
    SET_ADVANCED_SEARCH,
    RESET_ADVANCED_SEARCH,
    COMMENTS_IS_LOADING,
    COMMENTS_LOAD_SUCCESS,
    COMMENTS_LOAD_ERROR,
    COMMENTS_RESET,
    COURSE_LEADERSHIP_BOARD_IS_LOADING,
    COURSE_LEADERSHIP_BOARD_LOAD_SUCCESS,
    COURSE_LEADERSHIP_BOARD_LOAD_ERROR,
    SCHEDULE_IS_LOADING,
    SCHEDULE_LOAD_SUCCESS,
    SCHEDULE_LOAD_ERROR,
    RESET_SCHEDULE_DATA,
    MONTH_IS_LOADING,
    MONTH_LOAD_SUCCESS,
    MONTH_LOAD_ERROR,
    CLASSES_IS_LOADING,
    CLASSES_LOAD_SUCCESS,
    CLASSES_LOAD_ERROR,
    CATEGORIES_IS_LOADING,
    CATEGORIES_LOAD_SUCCESS,
    CATEGORIES_LOAD_ERROR,
    CATEGORY_ITEMS_IS_LOADING,
    CATEGORY_ITEMS_LOAD_SUCCESS,
    CATEGORY_ITEMS_LOAD_ERROR,
    CATEGORY_ITEMS_RESET,
    SET_SELECTED_SCHEDULE_ID,
    RESET_SELECTED_SCHEDULE_ID,
    LIVE_COURSES_IS_LOADING,
    LIVE_COURSES_LOAD_SUCCESS,
    LIVE_COURSES_LOAD_ERROR,
    SET_ACCESS_TOKEN,
    RESET_ACCESS_TOKEN,
    REGISTRATION_SUBJECTS_FAIL,
    REGISTRATION_SUBJECTS_SUCCESS,
    LIVE_SUBJECTS_FAIL,
    LIVE_SUBJECTS_SUCCESS,
    EXAM_SCHEDULE_IS_LOADING,
    EXAM_SCHEDULE_LOAD_SUCCESS,
    EXAM_SCHEDULE_LOAD_ERROR,
    EXAM_RESET_SCHEDULE_DATA,
    EXAM_ANSWER_SHEET_IS_LOADING,
    EXAM_ANSWER_SHEET_LOAD_SUCCESS,
    EXAM_ANSWER_SHEET_LOAD_ERROR,
    EXAM_ANSWER_SHEET_RESET_DATA,
    REPORTS_STUDENT_LIST_IS_LOADING,
    REPORTS_STUDENT_LIST_LOAD_SUCCESS,
    REPORTS_STUDENT_LIST_LOAD_ERROR,
    TUTOR_SUBJECTS_IS_LOADING,
    TUTOR_SUBJECTS_LOAD_SUCCESS,
    TUTOR_SUBJECTS_LOAD_ERROR,
    TUTOR_SUBJECT_EXAM_SCHEDULE_IS_LOADING,
    TUTOR_SUBJECT_EXAM_SCHEDULE_LOAD_SUCCESS,
    TUTOR_SUBJECT_EXAM_SCHEDULE_LOAD_ERROR,
    EXAM_SCHEDULE_STUDENT_IS_LOADING,
    EXAM_SCHEDULE_STUDENT_LOAD_SUCCESS,
    EXAM_SCHEDULE_STUDENT_LOAD_ERROR
} from "./action_types";
const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const openSlider = () => ({
    type: OPEN_SLIDER,
});

export const closeSlider = () => ({
    type: CLOSE_SLIDER,
});

export const selectedMenu = (itemIndex) => ({
    type: SELECTED_MENU_ITEM,
    payload: itemIndex,
});

export const setHeaderButtonParams = (buttonParams) => ({
    type: SET_HEADER_BUTTON_PARAMS,
    payload: buttonParams,
});

export const setHeaderText = (text) => ({
    type: SET_HEADER_TEXT,
    payload: text,
});

export const setHeaderAdvancedSearchParams = (params) => ({
    type: SET_HEADER_ADVANCED_SEARCH_PARAMS,
    payload: params
})

export const coursesIsLoading = () => ({
    type: COURSES_IS_LOADING,
});

export const courseLoadingSuccess = (coursesData) => ({
    type: COURSES_LOAD_SUCCESS,
    payload: coursesData,
});

export const courseLoadingError = (errorMessage) => ({
    type: COURSES_LOAD_ERROR,
    payload: errorMessage,
});

export const courseIntegrityError = () => ({
    type: COURSES_INTEGRITY_ERROR
})

export const resetIntegrityError = () => ({
    type: RESET_INTERGRITY_ERROR,
})

export const isSubmittingForm = () => ({
    type: IS_SUBMITTING,
});

export const formSubmitSuccess = () => ({
    type: SUBMIT_SUCCESS,
});

export const formSubmitError = (errorMessage) => ({
    type: SUBMIT_ERROR,
    payload: errorMessage,
});

export const resetFormStatus = () => ({
    type: RESET_FORM_STATUS,
});

export const isUpdatingForm = () => ({
    type: IS_UPDATING,
});

export const formUpdateSuccess = () => ({
    type: UPDATE_SUCCESS,
});

export const formUpdateError = (errorMessage) => ({
    type: UPDATE_ERROR,
    payload: errorMessage,
});

export const isSubmittingQuestionForm = () => ({
    type: IS_SUBMITTING_QUESTIONS,
});

export const questionFormSubmitSuccess = () => ({
    type: SUBMIT_QUESTIONS_SUCCESS,
});

export const questionFormSubmitError = (errorMessage) => ({
    type: SUBMIT_QUESTIONS_ERROR,
    payload: errorMessage,
});

export const resetQuestionFormStatus = () => ({
    type: RESET_QUESTIONS_FORM_STATUS,
});

export const quizzesIsLoading = () => ({
    type: QUIZZES_IS_LOADING,
});

export const quizzesLoadingSuccess = (quizzesData) => ({
    type: QUIZZES_LOAD_SUCCESS,
    payload: quizzesData,
});

export const resetQuizzesData = () => ({
    type: RESET_QUIZZES_DATA,
});

export const quizzesLoadingError = (errorMessage) => ({
    type: QUIZZES_LOAD_ERROR,
    payload: errorMessage,
});

export const setEdit = (id) => ({
    type: SET_EDIT,
    payload: id,
});

export const resetEdit = () => ({
    type: RESET_EDIT,
});

export const questionsLoading = () => ({
    type: IS_LOADING,
});

export const questionsLoadSuccess = (questions) => ({
    type: LOAD_SUCCESS,
    payload: questions,
});

export const questionsLoadError = (errorMessage) => ({
    type: LOAD_ERROR,
    payload: errorMessage,
});

export const resetLoadedQuestions = () => ({
    type: RESET_LOADED_QUESTIONS
})

export const getRandomEmployees = () => {
    let numberOfEmployees = Math.floor(Math.random() * 10) + 1;
    let employeesArray = [];
    for (let i = 0; i < numberOfEmployees; i++) {
        employeesArray.push(
            "./images/people/" + (Math.floor(Math.random() * 20) + 1) + ".jpg"
        );
    }
    return employeesArray;
};

export const calculateDateRange = (start, end) => {
    if(start){
        const startDate = start.split("-");
        const endDate = end.split("-");
        if (startDate[0] === endDate[0]) {
            if (startDate[1] === endDate[1]) {
                return `${months[startDate[1] - 1]} ${startDate[2]} - ${endDate[2]}, ${
            startDate[0]
          }`;
            } else {
                return `${months[startDate[1] - 1]} ${startDate[2]} - ${
            months[endDate[1] - 1]
          } ${endDate[2]}, ${startDate[0]}`;
            }
        } else {
            return `${months[startDate[1] - 1]} ${startDate[2]}, ${startDate[0]} - ${
          months[endDate[1] - 1]
        } ${endDate[2]}, ${endDate[0]}`;
        }
    }
   
};

export const formatDate = (date) => {
    const createdDate = date.split("-");
    return `Created on ${months[createdDate[1] - 1]} ${createdDate[2]}, ${createdDate[0]}`;
};

export const formatDateAnnouncements = (date) => {
    const createdDate = date.split("-");
    return `${months[createdDate[1] - 1]} ${createdDate[2]}, ${createdDate[0]}`;
};

export const getMonth = (date) => {
    console.log(date)
    const extractedMonth = date.split('-')[1]
    return months[extractedMonth - 1]
}

export const getDate = (date) => {
    return date.split('-')[2]
}

export const formatLiveCourseDateTime = (startTime) => {
    let startDateAndTime = new Date(Date.parse(startTime))
    let year = startDateAndTime.getFullYear()
    let month = (Number(startDateAndTime.getMonth()))
    let day = startDateAndTime.getDate()
    let hour = startDateAndTime.getHours()
    let minutes = startDateAndTime.getMinutes()
    return `${months[month]} ${day < 10 ? '0'+day : day}, ${year} at ${hour<10 ? '0'+hour:hour}:${minutes < 10 ? '0'+minutes : minutes} hrs`
}

export const settingsIsLoading = () => ({
    type: SETTINGS_IS_LOADING,
});

export const settingsLoadingSuccess = (settingsData) => ({
    type: SETTINGS_LOAD_SUCCESS,
    payload: settingsData,
});

export const settingsLoadingError = (errorMessage) => ({
    type: SETTINGS_LOAD_ERROR,
    payload: errorMessage,
});

export const announcementsIsLoading = () => ({
    type: ANNOUNCEMENTS_IS_LOADING,
});

export const announcementsLoadingSuccess = (announcementsData) => ({
    type: ANNOUNCEMENTS_LOAD_SUCCESS,
    payload: announcementsData,
});

export const announcementsLoadingError = (errorMessage) => ({
    type: ANNOUNCEMENTS_LOAD_ERROR,
    payload: errorMessage,
});

export const statisticsIsLoading = () => ({
    type: STATISTICS_IS_LOADING,
});

export const statisticsLoadingSuccess = (statisticsData) => ({
    type: STATISTICS_LOAD_SUCCESS,
    payload: statisticsData,
});

export const statisticsLoadingError = (errorMessage) => ({
    type: STATISTICS_LOAD_ERROR,
    payload: errorMessage,
});

export const leadershipBoardIsLoading = () => ({
    type: LEADERSHIP_BOARD_IS_LOADING,
});

export const leadershipBoardLoadingSuccess = (leadershipBoardData) => ({
    type: LEADERSHIP_BOARD_LOAD_SUCCESS,
    payload: leadershipBoardData,
});

export const leadershipBoardLoadingError = (errorMessage) => ({
    type: LEADERSHIP_BOARD_LOAD_ERROR,
    payload: errorMessage,
});

export const reportsIsLoading = () => ({
    type: REPORTS_IS_LOADING,
});

export const reportsLoadingSuccess = (reportsData) => ({
    type: REPORTS_LOAD_SUCCESS,
    payload: reportsData,
});

export const reportsLoadingError = (errorMessage) => ({
    type: REPORTS_LOAD_ERROR,
    payload: errorMessage,
});

export const selectedCourseIsLoading = () => ({
    type: SELECTED_COURSE_IS_LOADING
})

export const selectedCourseSuccess = (course) => ({
    type: SELECTED_COURSE_LOAD_SUCCESS,
    payload: course
})

export const selectedCourseError = (errorMessage) => ({
    type: SELECTED_COURSE_LOAD_ERROR,
    payload: errorMessage
})

export const resetSelectedCourse = () => ({
    type: RESET_SELECTED_COURSE
})

export const searchAutocompleteList = (list) => ({
    type: SEARCH_AUTOCOMPLETE_LIST_LOADING,
    payload: list
})

export const searchQuery = (query) => ({
    type: SEARCH_QUERY_LOADING,
    payload: query
})

export const searchFinal = (query) => ({
    type: SEARCH_FINAL_QUERY,
    payload: query
})

export const searchReset = () => ({
    type: SEARCH_COMPONENT_RESET
})

export const setAutocompleteVisibility = (value) => ({
    type: SET_AUTOCOMPLETE_VISIBILITY,
    payload: value
})

export const setCourseView = (view) => ({
    type: CURRENT_VIEW,
    payload: view
})

export const resetCourseView = () => ({
    type: RESET_VIEW
})

export const setAdvancedSearchParams = (params) => ({
    type: SET_ADVANCED_SEARCH,
    payload: params
})

export const resetAdvancedSearchParams = () => ({
    type: RESET_ADVANCED_SEARCH
})

export const loadComments = ()=>({
    type:COMMENTS_IS_LOADING
})

export const commentsLoadSuccess = (comments) => ({
    type:COMMENTS_LOAD_SUCCESS,
    payload: comments
})

export const commentsLoadError = (errorMessage) => ({
    type: COMMENTS_LOAD_ERROR,
    payload: errorMessage
})

export const resetComments = () => ({
    type: COMMENTS_RESET
})

export const courseLeadershipBoardIsLoading = () => ({
    type: COURSE_LEADERSHIP_BOARD_IS_LOADING,
});

export const courseLeadershipBoardLoadingSuccess = (courseLeadershipBoardData) => ({
    type: COURSE_LEADERSHIP_BOARD_LOAD_SUCCESS,
    payload: courseLeadershipBoardData,
});

export const courseLeadershipBoardLoadingError = (errorMessage) => ({
    type: COURSE_LEADERSHIP_BOARD_LOAD_ERROR,
    payload: errorMessage,
});


export const scheduleIsLoading = () => ({
    type: SCHEDULE_IS_LOADING,
});

export const scheduleLoadingSuccess = (scheduleData) => ({
    type: SCHEDULE_LOAD_SUCCESS,
    payload: scheduleData,
});

export const scheduleLoadingError = (errorMessage) => ({
    type: SCHEDULE_LOAD_ERROR,
    payload: errorMessage,
});

export const resetScheduleData = () => ({
    type:RESET_SCHEDULE_DATA
})

export const monthIsLoading = () => ({
    type: MONTH_IS_LOADING
})

export const monthLoadingSuccess = (monthData) => ({
    type: MONTH_LOAD_SUCCESS,
    payload: monthData
})

export const monthLoadingError = (error) => ({
    type: MONTH_LOAD_ERROR,
    payload: error
})

export const classesIsLoading = () => ({
    type: CLASSES_IS_LOADING,
});

export const classesLoadingSuccess = (classesData) => ({
    type: CLASSES_LOAD_SUCCESS,
    payload: classesData,
});

export const classesLoadingError = (errorMessage) => ({
    type: CLASSES_LOAD_ERROR,
    payload: errorMessage,
});

export const categoriesIsLoading = () => ({
    type: CATEGORIES_IS_LOADING,
});

export const categoriesLoadingSuccess = (categoriesData) => ({
    type: CATEGORIES_LOAD_SUCCESS,
    payload: categoriesData,
});

export const categoriesLoadingError = (errorMessage) => ({
    type: CATEGORIES_LOAD_ERROR,
    payload: errorMessage,
});

export const categoryItemsIsLoading = () => ({
    type: CATEGORY_ITEMS_IS_LOADING,
});

export const categoryItemsLoadingSuccess = (categoryItemsData) => ({
    type: CATEGORY_ITEMS_LOAD_SUCCESS,
    payload: categoryItemsData,
});

export const categoryItemsLoadingError = (errorMessage) => ({
    type: CATEGORY_ITEMS_LOAD_ERROR,
    payload: errorMessage,
});

export const categoryItemsReset = () => ({
    type: CATEGORY_ITEMS_RESET
})

export const setSelectedSchedule = (id) => ({
    type: SET_SELECTED_SCHEDULE_ID,
    payload: id
});

export const resetSelectedSchedule = () => ({
    type: RESET_SELECTED_SCHEDULE_ID,
});

export const liveCoursesIsLoading = () => ({
    type: LIVE_COURSES_IS_LOADING,
});

export const liveCourseLoadingSuccess = (liveCoursesData) => ({
    type: LIVE_COURSES_LOAD_SUCCESS,
    payload: liveCoursesData,
});

export const liveCourseLoadingError = (errorMessage) => ({
    type: LIVE_COURSES_LOAD_ERROR,
    payload: errorMessage,
});

//temporary fix for storing access token for live sessions
export const setAccessToken = (token) => ({
    type: SET_ACCESS_TOKEN,
    payload: token
})

export const resetAccessToken = () => ({
    type: RESET_ACCESS_TOKEN
})

export const regSubjectSuccess = (data) => ({
    type: REGISTRATION_SUBJECTS_SUCCESS,
    payload: data,
});

export const regSubjectFailError = (errorMessage) => ({
    type: REGISTRATION_SUBJECTS_FAIL,
    payload: errorMessage,
});

export const liveSubjectSuccess = (data) => ({
    type: LIVE_SUBJECTS_SUCCESS,
    payload: data,
});

export const liveSubjectFailError = (errorMessage) => ({
    type: LIVE_SUBJECTS_FAIL,
    payload: errorMessage,
});
export const ExamscheduleIsLoading = () => ({
    type: EXAM_SCHEDULE_IS_LOADING,
});

export const ExamscheduleLoadingSuccess = (ExamscheduleData) => ({
    type: EXAM_SCHEDULE_LOAD_SUCCESS,
    payload: ExamscheduleData,
});

export const ExamscheduleLoadingError = (errorMessage) => ({
    type: EXAM_SCHEDULE_LOAD_ERROR,
    payload: errorMessage,
});
export const ExamresetScheduleData = () => ({
    type:EXAM_RESET_SCHEDULE_DATA
})

export const ExamAnswerSheetIsLoading = () => ({
    type: EXAM_ANSWER_SHEET_IS_LOADING,
});

export const ExamAnswerSheetLoadingSuccess = (ExamAnswersData) => ({
    type: EXAM_ANSWER_SHEET_LOAD_SUCCESS,
    payload: ExamAnswersData,
});

export const ExamAnswerSheetLoadingError = (errorMessage) => ({
    type: EXAM_ANSWER_SHEET_LOAD_ERROR,
    payload: errorMessage,
});
export const ExamAnswerSheetreset = () => ({
    type:EXAM_ANSWER_SHEET_RESET_DATA
});

export const ReportsStudentListIsLoading = () => ({
    type: REPORTS_STUDENT_LIST_IS_LOADING,
});

export const ReportsStudentListLoadingSuccess = (ReportStudentListData) => ({
    type: REPORTS_STUDENT_LIST_LOAD_SUCCESS,
    payload: ReportStudentListData,
});

export const ReportsStudentListLoadingError = (errorMessage) => ({
    type: REPORTS_STUDENT_LIST_LOAD_ERROR,
    payload: errorMessage,
});

export const LoadTutorSubjectsIsLoading = () => ({
    type: TUTOR_SUBJECTS_IS_LOADING,
});

export const LoadTutorSubjectsLoadingSuccess = (TutorSubjectsList) => ({
    type: TUTOR_SUBJECTS_LOAD_SUCCESS,
    payload: TutorSubjectsList,
});

export const LoadTutorSubjectsLoadingError = (errorMessage) => ({
    type: TUTOR_SUBJECTS_LOAD_ERROR,
    payload: errorMessage,
});

export const LoadTutorSubjectExamSchedulesIsLoading = () => ({
    type: TUTOR_SUBJECT_EXAM_SCHEDULE_IS_LOADING,
});

export const LoadTutorSubjectExamSchedulesLoadingSuccess = (TutorSubjectExamSchedules) => ({
    type: TUTOR_SUBJECT_EXAM_SCHEDULE_LOAD_SUCCESS,
    payload: TutorSubjectExamSchedules,
});

export const LoadTutorSubjectExamSchedulesLoadingError = (errorMessage) => ({
    type: TUTOR_SUBJECT_EXAM_SCHEDULE_LOAD_ERROR,
    payload: errorMessage,
});

export const LoadExamScheduleStudentListIsLoading = () => ({
    type: EXAM_SCHEDULE_STUDENT_IS_LOADING,
});

export const LoadExamScheduleStudentListLoadingSuccess = (ExamScheduleStudentList) => ({
    type: EXAM_SCHEDULE_STUDENT_LOAD_SUCCESS,
    payload: ExamScheduleStudentList,
});

export const LoadExamScheduleStudentListLoadingError = (errorMessage) => ({
    type: EXAM_SCHEDULE_STUDENT_LOAD_ERROR,
    payload: errorMessage,
});